module.exports = __webpack_public_path__ + "img/tourism-pathway.5a2c7f6d.jpg";